import { Grid, IconButton, Typography, Paper, GridList, GridListTile, GridListTileBar, ListSubheader } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Participant from "./participant";
import VideocamIcon from "@material-ui/icons/Videocam";
import VideocamOffIcon from "@material-ui/icons/VideocamOff";
import MicIcon from '@material-ui/icons/Mic';
import MicOffIcon from '@material-ui/icons/MicOff';
import CallIcon from '@material-ui/icons/Call';

// update log
// FB 6036 MS   05/17/2022    Created
// FB 6163 DK   09/21/2022    UI changes on video call

const Room = ({ roomName, identity, room, handleLogout }) => {
  const [participants, setParticipants] = useState([]);
  const waitingRoom = document.getElementById("waiting-room");

  useEffect(() => {
    const participantConnected = (participant) => {
      setParticipants((prevParticipants) => [...prevParticipants, participant]);
    };

    const participantDisconnected = (participant) => {
      setParticipants((prevParticipants) =>
        prevParticipants.filter((p) => p !== participant)
      );
    };

    room.on("participantConnected", participantConnected);
    room.on("participantDisconnected", participantDisconnected);
    room.participants.forEach(participantConnected);
    return () => {
      room.off("participantConnected", participantConnected);
      room.off("participantDisconnected", participantDisconnected);
    };
  }, [room]);

  const remoteParticipants = participants.map((participant) => (
    waitingRoom.style.display = room.localParticipant.identity || participant.identity == "provider" ? "none" : "",
    // FB 6163
    <Participant key={participant.sid} participant={participant} type="remote" />
  ));

  function handleMuteUnmute() {
    const muteAudio = document.getElementById("muteAudio");
    const unmuteAudio = document.getElementById("unmuteAudio");
    muteAudio.style.display = (
      muteAudio.style.display == "none" ? "block" : "none");
    unmuteAudio.style.display = (
      unmuteAudio.style.display == "none" ? "block" : "none");
    room.localParticipant.audioTracks.forEach(track => {
      if (muteAudio.style.display == "none")
        track.track.disable();
      else
        track.track.enable();
    });
  }

  function handleShowHide() {
    const showCam = document.getElementById("showCam");
    const hideCam = document.getElementById("hideCam");
    showCam.style.display = (
      showCam.style.display == "none" ? "block" : "none");
    hideCam.style.display = (
      hideCam.style.display == "none" ? "block" : "none");
    room.localParticipant.videoTracks.forEach(track => {
      if (showCam.style.display == "none")
        track.track.disable();
      else
        track.track.enable();
    });
  }

  return (
    // FB 6163 - Start
    <Grid container spacing={3} direction="row" style={{ display: "flex", justifyContent: "center", alignContent: "center", backgroundColor: "#282A35", minHeight: "40vh" }}>
      <Grid item style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
        {remoteParticipants}
      </Grid>
      <Grid item style={{ display: "flex", alignSelf: "flex-end" }}>
        {
          room ? (
            room.localParticipant.identity != "provider" ? (
              <div>
                <div id="waiting-room" class="hidden" style={{ color: "white", textAlign: "center" }}>
                  <p>Thanks! Your provider will be with you shortly.</p>
                </div>
                <Participant
                  key={room.localParticipant.sid}
                  participant={room.localParticipant}
                  type="self"
                />
              </div>
            ) : (
              <div>
                <div id="waiting-room" style={{ display: "none", color: "white" }}>
                  <p>Thanks! Your provider will be with you shortly.</p>
                </div>
                <Participant
                  key={room.localParticipant.sid}
                  participant={room.localParticipant}
                  type="self"
                />
              </div>
            )
          ) :
            (
              <>
              </>
            )
        }
      </Grid>
      <Grid item xs={10} style={{ display: "flex", alignContent: "center", justifyContent: "center", padding: "5px" }}>
        <IconButton
          aria-label="Mute"
          style={{ background: "aliceblue", marginRight: "15px" }}
          onClick={() =>
            handleMuteUnmute()
          }
        >
          <MicIcon id="muteAudio"
            style={{ display: "block", color: "black" }}
            fontSize="large"
          />
          <MicOffIcon id="unmuteAudio"
            style={{ display: "none", color: "black" }}
            fontSize="large"
          />
        </IconButton>
        <IconButton
          aria-label="Show"
          style={{ background: "aliceblue", marginRight: "15px" }}
          onClick={() =>
            handleShowHide()
          }
        >
          <VideocamIcon id="showCam"
            style={{ display: "block", color: "black" }}
            fontSize="large"
          />
          <VideocamOffIcon id="hideCam"
            style={{ display: "none", color: "black" }}
            fontSize="large"
          />
        </IconButton>
        <IconButton
          aria-label="end"
          style={{ background: "red" }}
          onClick={() =>
            handleLogout()
          }
        >
          <CallIcon id="showCam"
            style={{ display: "block", color: "black" }}
            fontSize="large"
          />
        </IconButton>
      </Grid>
    </Grid>
    // FB 6163 - End
  );
};

export default Room;
